/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LogModel } from './LogModel';
import {
    LogModelFromJSON,
    LogModelFromJSONTyped,
    LogModelToJSON,
    LogModelToJSONTyped,
} from './LogModel';

/**
 * 
 * @export
 * @interface GetLogsResponse
 */
export interface GetLogsResponse {
    /**
     * 
     * @type {Array<LogModel>}
     * @memberof GetLogsResponse
     */
    items?: Array<LogModel>;
    /**
     * 
     * @type {number}
     * @memberof GetLogsResponse
     */
    numberOfItems?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLogsResponse
     */
    numberOfPages?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLogsResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the GetLogsResponse interface.
 */
export function instanceOfGetLogsResponse(value: object): value is GetLogsResponse {
    return true;
}

export function GetLogsResponseFromJSON(json: any): GetLogsResponse {
    return GetLogsResponseFromJSONTyped(json, false);
}

export function GetLogsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLogsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(LogModelFromJSON)),
        'numberOfItems': json['numberOfItems'] == null ? undefined : json['numberOfItems'],
        'numberOfPages': json['numberOfPages'] == null ? undefined : json['numberOfPages'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function GetLogsResponseToJSON(json: any): GetLogsResponse {
    return GetLogsResponseToJSONTyped(json, false);
}

export function GetLogsResponseToJSONTyped(value?: GetLogsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(LogModelToJSON)),
        'numberOfItems': value['numberOfItems'],
        'numberOfPages': value['numberOfPages'],
        'pageSize': value['pageSize'],
    };
}

